<template>
  <div class="header-warp">
    <div class="pc-header">
      <div class="site-nav">
        <div class="warp clearfix">
          <div class="left" v-if="userInfo.username">
            <div class="welcome" @mouseover="isShowOut = true" @mouseleave="isShowOut = false">
              欢迎你 {{userInfo.nickname||userInfo.username}}
              <span class="iconfont hoverShowOut">&#xe695;</span>
              <div class="outLogin" v-show="isShowOut" @click="outLoginBtn">退出登录</div>
            </div>
          </div>
          <div class="left" v-else>
            你好 请先 <span @click="loginBtn(2)">登录</span> 或 <span @click="loginBtn(1)">注册</span>
          </div>
          <div class="right">
            <!-- <div class="item">
              <a class="hover-item">申请入驻</a>
            </div> -->
            <div class="item">
              <a class="hover-item" @click="goToUserOrder">我的订单</a>
            </div>
            <div class="item item-select">
              <span class="hover-item" @click="goToShopCart"><i class="iconfont icon-shoppingCart"></i>购物车<span v-if="isShowNum">(<b v-text="cartNumber === 0 ? '0' : cartNumber"></b>)</span><i class="ico-arrow el-icon-arrow-down"></i></span>
              <div v-if="!isLogin" class="cart-box cart-no-login">
                <a class="btn" @click="loginBtn">登录</a>
                <p class="p">登录后查看商品</p>
              </div>
              <div v-else-if="shoppingCart.length === 0" class="cart-box cart-no-data">
                <p class="p">购物车还没有商品，赶紧选购吧！</p>
              </div>
              <!-- <div v-else class="cart-box cart-list">
                <div v-for="shop in shoppingCart" :key="shop.id">
                  <dl v-for="(item, index) in shop.skus" :key="index" v-if="index<5">
                    <dt>
                      <div class="cartImgBox" style="width: 42px;height: 42px;background: #F5F5F5;" @click="$router.push('/shopping-trolley')">
                        <img :src="shop.productInfo.image" alt="">
                      </div>
                    </dt>
                    <dd>
                      <h4 class="h4" @click="$router.push('/shopping-trolley')">{{shop.productInfo.storeName}}</h4>
                      <p>{{item.SKU}}</p>
                      <span>￥{{shop.truePrice}}</span>
                      <a class="btn-del" @click="deleteCartItem(shop)">删除</a>
                    </dd>
                  </dl>
                </div>
                <a class="btn-view-all" @click="goToShopCart" v-if="cartNumber>5">查看全部</a>
              </div> -->

         <div  class="cart-box cart-list" v-if="shoppingCart.length > 0">
            <div v-for="(item,index) in shoppingCart" v-if="index <= 4" :key="item.id" style="" class="shoppingCartBox">
              <img :src="item.productInfo.image" alt="" style="width: 42px;height: 42px;flex: 1;">
              <h4 class="h4" @click="$router.push('/shopping-trolley')" style="flex: 6;">{{item.productInfo.storeName}}</h4>
              <div class="cart_right" style="flex: 1;">
                <span>￥{{item.truePrice}}</span>
                <a href="" @click.prevent="confirDelete(item)">删除</a>
              </div>
            <!-- <pre>{{item}}</pre> -->
            </div>
            <a class="btn-view-all" @click="goToShopCart" v-if="shoppingCart.length>=4">查看全部</a>
          </div>
            </div>
            <div class="item item-select">
              <span class="hover-item"><i class="iconfont icon-user"></i>我的<i class="ico-arrow el-icon-arrow-down"></i></span>
              <div class="cart-box user-box">
                <ul>
                  <li @click="goToUserInfo">个人信息</li>
                  <li @click="goToUserOrder">我的订单</li>
                  <li @click="goToUserAddress">收货地址</li>
                  <li @click="gotoUserCoupon">券包</li>
                  <li @click="gotoReceiveCoupon">领优惠券</li>
                  <li @click="gotoMyCollect">我的收藏</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="outLoginDialog"
      width="30%">
      <span>确定退出登录吗？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="outLoginDialog = false">取 消</el-button>
    <el-button type="primary" @click="outLogin">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {listSearchMixin} from '../../config/mixin'
import Cookie from 'js-cookie'
import api from '@/api'
  export default {
    mixins: [listSearchMixin],
    name: 'siteNav',
    props: {
      componentContent: {
        type: Object
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'shoppingCart',
        'cartNumber'
      ])
    },
    data () {
      return {
        isShowOut: false,
        menuOpen: false,
        isLogin: true,
        outLoginDialog: false,
        isShowNum: false,
        deleteOpt: {
          visiable: false
        },
        proList: [
          {
            title: '商品名称',
            text: '净含量经典',
            price: '99.90'
          }, {
            title: '商品名称',
            text: '净含量经典',
            price: '99.90'
          }, {
            title: '商品名称',
            text: '净含量经典',
            price: '99.90'
          }, {
            title: '商品名称',
            text: '净含量经典',
            price: '99.90'
          }, {
            title: '商品名称',
            text: '净含量经典',
            price: '99.90'
          }, {
            title: '商品名称',
            text: '净含量经典',
            price: '99.90'
          }
        ]
      }
    },
    created () {
      if (Cookie.get('token')) {
        this.isShowNum = true
        this.getTrolleyList()
      }
			console.log(this.shoppingCart)
			console.log(123123)
    },
    methods: {
      ...mapMutations({
        setUserInfo: 'SET_USERINFO',
        setCartNumber: 'SET_CARTNUMBER',
        setShoppingCart: 'SET_SHOPPINGCART',
        setNewAddress: 'SET_NEWADDRESS',
        setAreaCode: 'SET_AREACODE',
		subCartNum: 'subCartNum'
      }),
	  // 确认是否删除商品
	  confirDelete(info) {
	     var ids =[];
	     ids.push(info.id)
	   console.log(ids)
	   if(ids.length == 0) return
	      this.deleteGood(ids);
	  },
	  // 删除单个商品
	  deleteGood(ids) {
	    let params;
	    params = {
	      url: api.deleteGoods,
	      method: "post",
	      data: {
	        ids: ids,
	      },
	    };
	    this.sendReq(params, (res) => {
			console.log(res)
			if(res.status != 200) return this.$message.success(res.msg)
			ids.forEach(item=> {
			  this.shoppingCart.splice(this.shoppingCart.findIndex(item1=>item1.id == item),1)
			})
			this.subCartNum(1)
	        this.$message.success('删除成功')
	    });
	  },

      // 购物车列表
      async getTrolleyList () {
        const vm = this
        const params = {
          url: api.getTrolleyList,
          method: 'GET'
        }
        vm.sendReq(params, res => {
          const d = res.data.valid
          let cartNumber = 0;
          cartNumber=d.length;
          this.setShoppingCart(d)
          this.setCartNumber(cartNumber)
        })
      },
      // 删除单个商品
      deleteCartItem (item) {
        // const id = info.skuId
        let ids = []
        ids.push(item.skuId)
        let params
        params = {
          url: api.deleteGoods,
          method: 'DELETE',
          data: {
            ids: ids
          }
        }
        this.sendReq(params, res => {

            let id = item.skuId
            this.shoppingCart.map(j => {
              j.skus.map(k => {
                if (k.skuId === id) {
                  j.skus.splice(j.skus.findIndex(item => item.skuId === id), 1)
                }
              })
            })
          this.setCartNumber(this.cartNumber - 1)
          this.$message.success('删除成功')
        })
      },
      outLoginBtn () {
        this.outLoginDialog = true
      },
      outLogin () {
        this.outLoginDialog = false
        Cookie.remove('token')
        this.setUserInfo({})
        this.setCartNumber('')
        this.setShoppingCart({})
        this.setNewAddress({})
        this.setAreaCode([])
        this.$router.push({path: '/login', query: {type: 2}})
      },
      goToUserInfo () {
        this.$router.push({path: '/userInfo'})
      },
      goToUserOrder () {
        this.$router.push({path: '/myOrder'})
      },
      loginBtn (type) {
        this.$router.push({path: '/login', query: {type: type}})
      },
      goToUserAddress () {
        this.$router.push({path: '/signingAddress'})
      },
      gotoUserCoupon () {
        this.$router.push({path: '/couponPackage'})
      },
      goToShopCart () {
        this.$router.push({path: '/shopping-trolley'})
      },
      gotoReceiveCoupon(){
        this.$router.push({path: '/receiveCoupon'})
      },
      gotoMyCollect(){
        this.$router.push({path: '/myCollect'})
      },
      hover () {
        this.isShowOut = true
      }
    }
  }
</script>

<style lang="scss" scoped>
	.shoppingCartBox {
		display: flex;
		justify-content: space-between;
		padding: 5px;
		border-bottom: 1px solid #f2f2f2;
		h4 {
			font-size: 10px;
			line-height: 15px;
			padding: 0 5px;
		}
		.cart_right {
			line-height: normal;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			a {
				color: #6d9dbe;
			}
		}
	}
  .site-nav{
    height: 36px;
    background-color: #F1F2F7;
    line-height: 36px;
    font-size: 12px;
    .welcome {
      position: relative;
      .outLogin {
        position: absolute;
        width: 100%;
        z-index: 999;
        background: #FFFFFF;
        text-align: center;
        cursor: pointer;
        box-shadow:0 0 20px #cccccc;
      }
    }
    .left{
      float: left;
      span{
        color: black;
        cursor: pointer;
      }
    }
    .right{
      float: right;
      .item{
        padding: 0 15px;
        display: inline-block;
        span{
          cursor: pointer;
          b{
            //color: black;
            padding: 0 2px;
          }
        }
        .iconfont{
          margin-right: 5px;
        }
        .icon-user{
          font-size: 12px;
        }
        &.item-select{
          padding-right: 33px;
          position: relative;
          .ico-arrow{
            position: absolute;
            right: 15px;
            top: 0;
            margin-right: 0;
            line-height: 43px;
          }
        }
        &:hover{
          background-color: #fff;
          .cart-no-data,.cart-no-login{
            display: flex;
          }
          .cart-list,.user-box{
            display: block;
          }
          .hover-item{
            color: $mainColor;
          }
        }
      }
    }
    .cart-box{
      position: absolute;
      top: 100%;
      background-color: #fff;
      z-index: 9;
      border-radius: 0px 0px 4px 4px;
      box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.06);
      .cartImgBox {
        img {
          width: 100%;
        }
      }
      &.cart-no-login{
        width: 100%;
        left: 0;
        height: 160px;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .btn{
          display: inline-block;
          padding: 0 15px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          background-color: $mainColor;
          border-radius: 4px;
          margin-bottom: 40px;
        }
        .p{
          color: #666666;
          line-height: 1em;
        }
      }
      &.cart-no-data{
        width: 264px;
        height: 110px;
        left: 50%;
        margin-left: -132px;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #666;
      }
      &.cart-list{
        width: 348px;
        left: 50%;
        margin-left: -174px;
        display: none;
        padding: 10px;
        dl{
          margin-bottom: 10px;
          dt{
            float: left;
            cursor: pointer;
          }
          dd{
            margin-left: 54px;
            position: relative;
            padding-right: 60px;
            min-height: 42px;
            line-height: 21px;
            h4{
              color: #333;
              cursor: pointer;
              font-size: 10px !important;
              @include ellipsis;
            }
            p{
              color: #999;
              font-size: 12px;
              @include ellipsis;
            }
            span{
              color: $mainColor;
              position: absolute;
              top: 0;
              right: 0;
              font-size: 12px;
            }
            .btn-del{
              color: #333;
              position: absolute;
              top: 20px;
              right: 0;
              font-size: 12px;
            }
          }
        }
        .btn-view-all{
          display: inline-block;
          float: right;
          padding: 0 15px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          background-color: $mainColor;
          border-radius: 4px;
          margin-top: 10px;
          cursor: pointer;
        }
      }
      &.user-box{
        width: 100%;
        left: 0;
        padding: 9px 0;
        display: none;
        li{
          font-size: 12px;
          display: block;
          cursor: pointer;
          color: #666;
          text-align: center;
          &:hover{
            background-color: #FFEEE3;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/siteNav.vue